package team.platforma.multiplatform_material_extension.ui.chip.style

import androidx.compose.foundation.BorderStroke
import androidx.compose.material3.InputChipDefaults
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SelectableChipColors
import androidx.compose.material3.SelectableChipElevation

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp


object ExtraInputChipStyle {
    internal var mShape: Shape? = null
    internal var mInputChipColors: InputChipColors = InputChipColors()
    internal var mInputChipElevation: InputChipElevation = InputChipElevation()
    internal var mInputChipBorder: InputChipBorder = InputChipBorder(enabled = true, selected = true)
    internal var mLabelTextStyle: TextStyle? = null
    internal var mChipHeight : Dp? = null

    fun define(
        shape: Shape? = null,
        inputChipColors: InputChipColors? = null,
        inputChipElevation: InputChipElevation? = null,
        inputChipBorder: InputChipBorder? = null,
        labelTextStyle: TextStyle? = null,
        chipHeight : Dp? = null
    ) {
        mShape = shape
        mInputChipColors = inputChipColors ?: InputChipColors()
        mInputChipElevation = inputChipElevation ?: InputChipElevation()
        mInputChipBorder = inputChipBorder ?: InputChipBorder(enabled = true, selected = true)
        mLabelTextStyle = labelTextStyle
        mChipHeight = chipHeight
    }
}

@Composable
internal fun extraInputChipShape(): Shape {
    return ExtraInputChipStyle.mShape ?: InputChipDefaults.shape
}

@Composable
internal fun extraInputChipColors(): SelectableChipColors {
    val global = ExtraInputChipStyle.mInputChipColors
    return InputChipDefaults.inputChipColors(
        containerColor = global.containerColor ?: Color.Unspecified,
        labelColor = global.labelColor ?: Color.Unspecified,
        leadingIconColor = global.leadingIconColor ?: Color.Unspecified,
        trailingIconColor = global.trailingIconColor ?: Color.Unspecified,
        disabledContainerColor = global.disabledContainerColor ?: Color.Unspecified,
        disabledLabelColor = global.disabledLabelColor ?: Color.Unspecified,
        disabledLeadingIconColor = global.disabledLeadingIconColor ?: Color.Unspecified,
        disabledTrailingIconColor = global.disabledTrailingIconColor ?: Color.Unspecified,
        selectedContainerColor = global.selectedContainerColor ?: Color.Unspecified,
        disabledSelectedContainerColor = global.disabledSelectedContainerColor ?: Color.Unspecified,
        selectedLabelColor = global.selectedLabelColor ?: Color.Unspecified,
        selectedLeadingIconColor = global.selectedLeadingIconColor ?: Color.Unspecified,
        selectedTrailingIconColor = global.selectedTrailingIconColor ?: Color.Unspecified
    )
}

//internal fun extraInputChipColorsData():InputChipColors {
//    return ExtraInputChipStyle.mInputChipColors
//}


data class InputChipColors(
    var containerColor: Color? = null,
    var labelColor: Color? = null,
    var leadingIconColor: Color? = null,
    var trailingIconColor: Color? = null,
    var disabledContainerColor: Color? = null,
    var disabledLabelColor: Color? = null,
    var disabledLeadingIconColor: Color? = null,
    var disabledTrailingIconColor: Color? = null,
    var selectedContainerColor: Color? = null,
    var disabledSelectedContainerColor: Color? = null,
    var selectedLabelColor: Color? = null,
    var selectedLeadingIconColor: Color? = null,
    var selectedTrailingIconColor: Color? = null
)

@Composable
internal fun extraInputChipElevation(): SelectableChipElevation {
    val global = ExtraInputChipStyle.mInputChipElevation
    return InputChipDefaults.inputChipElevation(
        elevation = global.elevation ?: 0.dp,
        pressedElevation = global.pressedElevation ?: 0.dp,
        focusedElevation = global.focusedElevation ?: 0.dp,
        hoveredElevation = global.hoveredElevation ?: 0.dp,
        draggedElevation = global.draggedElevation ?: 0.dp,
        disabledElevation = global.disabledElevation ?: 0.dp
    )
}

data class InputChipElevation(
    var elevation: Dp? = null,
    var pressedElevation: Dp? = null,
    var focusedElevation: Dp? = null,
    var hoveredElevation: Dp? = null,
    var draggedElevation: Dp? = null,
    var disabledElevation: Dp? = null,
)

@Composable
internal fun extraInputChipBorder(selected: Boolean): BorderStroke {
    val global = ExtraInputChipStyle.mInputChipBorder
    return InputChipDefaults.inputChipBorder(
        enabled = global.enabled ,
        selected = global.selected,
        borderColor = global.borderColor ?: Color.Transparent,
        selectedBorderColor = if (selected) global.selectedBorderColor ?: Color.Transparent else global.borderColor ?: MaterialTheme.colorScheme.primary ,
        disabledBorderColor = global.disabledBorderColor ?: MaterialTheme.colorScheme.onSurface,
        disabledSelectedBorderColor = global.disabledSelectedBorderColor ?: MaterialTheme.colorScheme.surface ,
        borderWidth = global.borderWidth ?: 1.dp,
        selectedBorderWidth = global.selectedBorderWidth ?: 1.dp
    )
}

data class InputChipBorder(
    var enabled: Boolean,
    var selected: Boolean,
    var borderColor: Color? = null,
    var selectedBorderColor: Color? = null,
    var disabledBorderColor: Color? = null,
    var disabledSelectedBorderColor: Color? = null,
    var borderWidth: Dp? = null,
    var selectedBorderWidth: Dp? = null
)

@Composable
internal fun extraInputChipLabelTextStyle(): TextStyle {
    return ExtraInputChipStyle.mLabelTextStyle ?: MaterialTheme.typography.bodyMedium
}

@Composable
internal fun extraInputChipHeight(): Dp {
    return ExtraInputChipStyle.mChipHeight ?: 32.dp
}